import { Deserializable } from '../protocols/deserializable';
import { SpousalWaiverAttachment } from './spousal-waiver-attachment';
import { GoverningJurisdictionType } from '../employers/employer-history/types/governing-jurisdiction-type';
import { GoverningJurisdictionTypeId } from '../enum/shared/governing-jurisdiction-type-id';

export class MonthlyPensionSpousalWaiver extends SpousalWaiverAttachment implements Deserializable {
  public governingJurisdictionId!: GoverningJurisdictionTypeId;
  public governingJurisdiction!: GoverningJurisdictionType | null;

  public onDeserialize() {
    super.onDeserialize();
    if (this.governingJurisdiction) {
      this.governingJurisdiction = window.injector.Deserialize.instanceOf(
        GoverningJurisdictionType,
        this.governingJurisdiction
      );
    }
  }
}
